import { Environment } from '@utils/envUtils';

// The backend strips Huawei load balancer hosts from EPG raw metadata urls (e.g. "/CPS/images/a.jpg") so that
// host changes don't create revisions. Prefix the host for the current environment to make the links usable.
export const huaweiHosts: Record<Environment, string> = {
  prod: 'https://digitvvscallc1.envision.services.altibox.net:443',
  at: 'https://mrotvottvscpcstg01.at.envision.services.altibox.net:443',
  dev: 'https://digitvvscallc1.envision.services.altibox.net:443',
  local: 'https://digitvvscallc1.envision.services.altibox.net:443',
};

const isStrippedPath = (value: string) => value.startsWith('/') && !value.startsWith('//');

/**
 * Recursively prefixes host-stripped paths in Huawei EPG raw metadata with the Huawei host for an environment.
 * Older revisions with full urls are left as is.
 */
export const withHuaweiHosts = (value: unknown, host: string): unknown => {
  if (typeof value === 'string') return isStrippedPath(value) ? `${host}${value}` : value;
  if (Array.isArray(value)) return value.map(item => withHuaweiHosts(item, host));
  if (value && typeof value === 'object')
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, withHuaweiHosts(item, host)])
    );

  return value;
};
